export default __webpack_public_path__ + "static/media/profile5.fc81fc30.png";